var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 22.5C45 34.9313 34.9172 45 22.5 45C10.0687 45 0 34.9313 0 22.5C0 10.0828 10.0687 0 22.5 0C34.9172 0 45 10.0828 45 22.5Z",
    fill: "#E24B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0004 22.5C45.0004 34.9312 34.9176 45 22.5004 45C15.4129 45 9.08476 41.7234 4.97852 36.6046C8.83164 39.6984 13.7113 41.5406 19.041 41.5406C31.4582 41.5406 41.541 31.4718 41.541 19.0406C41.541 13.7109 39.6988 8.83121 36.591 4.97809C41.7238 9.0984 45.0004 15.4125 45.0004 22.5Z",
    fill: "#D03F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8826 18.0679C17.5985 18.0679 17.33 17.9301 17.1654 17.6967C15.6087 15.5001 13.4839 14.0995 10.4759 13.2923C10.0076 13.1657 9.72917 12.6834 9.85573 12.2151C9.9823 11.7454 10.4618 11.4712 10.9329 11.5949C13.8396 12.3768 16.1037 13.717 17.8137 15.6801L19.047 13.7732C19.3085 13.3654 19.8556 13.2487 20.2606 13.5117C20.6684 13.776 20.7851 14.3189 20.5221 14.7267L18.6209 17.6657C18.4634 17.9104 18.1934 18.0609 17.9023 18.0679C17.8939 18.0679 17.8868 18.0679 17.8826 18.0679Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2553 26.0592C16.2171 26.0592 17.8075 24.251 17.8075 22.0205C17.8075 19.7899 16.2171 17.9817 14.2553 17.9817C12.2935 17.9817 10.7031 19.7899 10.7031 22.0205C10.7031 24.251 12.2935 26.0592 14.2553 26.0592Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.116 18.0661C27.109 18.0661 27.1033 18.0661 27.0963 18.0661C26.8052 18.0604 26.5366 17.9086 26.3763 17.6639L24.4765 14.7248C24.2135 14.317 24.3302 13.7728 24.738 13.5098C25.1444 13.2454 25.69 13.3636 25.953 13.7714L27.1835 15.6768C28.8949 13.7151 31.1575 12.3736 34.0657 11.5931C34.5368 11.4651 35.0163 11.7436 35.1429 12.2133C35.2694 12.6815 34.991 13.1639 34.5227 13.2904C31.5147 14.099 29.3899 15.4983 27.8318 17.6962C27.6686 17.9283 27.4001 18.0661 27.116 18.0661Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7426 26.0592C32.7044 26.0592 34.2948 24.251 34.2948 22.0205C34.2948 19.7899 32.7044 17.9817 30.7426 17.9817C28.7808 17.9817 27.1904 19.7899 27.1904 22.0205C27.1904 24.251 28.7808 26.0592 30.7426 26.0592Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.969 35.2814C27.311 33.5475 24.94 32.5547 22.4608 32.5547C19.9816 32.5547 17.6107 33.5489 15.9527 35.2814C15.4141 35.8439 14.5225 35.8608 13.9643 35.325C13.4032 34.7878 13.3835 33.8976 13.9207 33.3365C16.1074 31.0514 19.2194 29.7422 22.4608 29.7422C25.7036 29.7422 28.8157 31.0528 31.001 33.3365C31.5382 33.8976 31.5185 34.7878 30.9574 35.325C30.3991 35.8608 29.5075 35.8439 28.969 35.2814Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7193 21.465C32.4156 21.5874 32.0289 21.3328 31.846 20.8941C31.6745 20.4539 31.7715 20.0011 32.0753 19.8788C32.3903 19.755 32.7784 20.0095 32.9485 20.4497C33.1314 20.8871 33.0231 21.3427 32.7193 21.465Z",
    fill: "#5A5F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0858 21.465C15.7821 21.5874 15.3954 21.3328 15.2126 20.8941C15.0424 20.4539 15.138 20.0011 15.4432 19.8788C15.7582 19.755 16.1463 20.0095 16.3165 20.4497C16.4979 20.8871 16.3896 21.3427 16.0858 21.465Z",
    fill: "#5A5F63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngry);
export default __webpack_public_path__ + "static/media/angry.d99c35a157874ba947c04b0ea5bb0801.svg";
export { ForwardRef as ReactComponent };